import { GlobalOptionsService } from '@common/ApiService'
const SET_CUSTOMER_TITLES = 'SET_CUSTOMER_TITLES'
const SET_RESERVATIONS_AUTO_CANCEL_TIME_INTERVAL =
  'SET_RESERVATIONS_AUTO_CANCEL_TIME_INTERVAL'

export const state = {
  customerTitles: null,
  reservationsAutoCancelTimeInterval: null,
}

export const mutations = {
  [SET_CUSTOMER_TITLES](state, data) {
    state.customerTitles = data
    return state
  },

  [SET_RESERVATIONS_AUTO_CANCEL_TIME_INTERVAL](state, data) {
    state.reservationsAutoCancelTimeInterval = data
  },
}

export const actions = {
  setCustomerTitles({ commit }) {
    if (!state.customerTitles) {
      return GlobalOptionsService.getCustomerTitles().then((response) => {
        commit(SET_CUSTOMER_TITLES, response.data)
      })
    }
  },

  setReservationsAutoCancelTimeInterval({ commit }) {
    if (!state.reservationsAutoCancelTimeInterval) {
      return GlobalOptionsService.getReservationsAutoCancelTimeInterval().then(
        (response) => {
          commit(SET_RESERVATIONS_AUTO_CANCEL_TIME_INTERVAL, response.data)
        }
      )
    }
  },
}
